/** @file duplicateClipCommands: the batch that copies a clip under a free name (create, meta, keys, tracks). */
import type { Command } from '@zilo/pose3d-commands/types/command';
import type { Clip } from '@zilo/pose3d-format/types/clip';
import { uniqueNodeName } from '../tree/uniqueNodeName';

/** `clip.create` + `clip.setMeta` + `clip.setKeys replace` (+ one `clip.setTrack` per track) for `<name>Copy`. */
export function duplicateClipCommands(clips: Record<string, Clip>, name: string): Command[] {
  const c = clips[name];
  if (c === undefined) return [];
  const copy = uniqueNodeName(clips, `${name}Copy`);
  const meta = { loopStart: c.loopStart, start: c.start, mirrorHalf: c.mirrorHalf, ...(c.facingSteps === undefined ? {} : { facingSteps: c.facingSteps }) };
  const out: Command[] = [
    { name: 'clip.create', input: { name: copy, frames: c.frames, fps: c.fps, loop: c.loop, category: c.category } },
    { name: 'clip.setMeta', input: { clip: copy, fields: meta } },
  ];
  if (c.keys.length > 0) out.push({ name: 'clip.setKeys', input: { clip: copy, keys: structuredClone(c.keys), merge: 'replace' } });
  for (const [node, track] of Object.entries(c.tracks ?? {})) out.push({ name: 'clip.setTrack', input: { clip: copy, node, track: structuredClone(track) } });
  return out;
}
